module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Influencer-Video-2.0e14a9bf.jpg";